/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Template_Category_NameInputs */

const en__field_template_category_name = /** @type {(inputs: _Field_Template_Category_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const de__field_template_category_name = /** @type {(inputs: _Field_Template_Category_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {_Field_Template_Category_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_template_category_name = /** @type {((inputs?: _Field_Template_Category_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Template_Category_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_template_category_name(inputs)
	return de__field_template_category_name(inputs)
});